import Immutable from 'immutable';

export const GET_ADDRESSBOOKS = 'takeback/api/ADDRESSBOOKS';
export const GET_ADDRESSBOOKS_SUCCESS = 'takeback/api/ADDRESSBOOKS_SUCCESS';
export const GET_ADDRESSBOOKS_FAILURE = 'takeback/api/ADDRESSBOOKS_FAILURE';

export const CREATE_ADDRESSBOOK = 'takeback/api/CREATE_ADDRESSBOOK';
export const CREATE_ADDRESSBOOK_SUCCESS = 'takeback/api/CREATE_ADDRESSBOOK_SUCCESS';
export const CREATE_ADDRESSBOOK_FAILURE = 'takeback/api/CREATE_ADDRESSBOOK_FAILURE';

export const LEAVE_ADDRESSBOOK = 'takeback/api/LEAVE_ADDRESSBOOK';
export const LEAVE_ADDRESSBOOK_SUCCESS = 'takeback/api/LEAVE_ADDRESSBOOK_SUCCESS';
export const LEAVE_ADDRESSBOOK_FAILURE = 'takeback/api/LEAVE_ADDRESSBOOK_FAILURE';

export const INVITE_ADDRESSBOOK = 'takeback/api/INVITE_ADDRESSBOOK';
export const INVITE_ADDRESSBOOK_SUCCESS = 'takeback/api/INVITE_ADDRESSBOOK_SUCCESS';
export const INVITE_ADDRESSBOOK_FAILURE = 'takeback/api/INVITE_ADDRESSBOOK_FAILURE';

export const PROMOTE_ADDRESSBOOK_USER = 'takeback/api/PROMOTE_ADDRESSBOOK_USER';
export const PROMOTE_ADDRESSBOOK_USER_SUCCESS = 'takeback/api/PROMOTE_ADDRESSBOOK_USER_SUCCESS';
export const PROMOTE_ADDRESSBOOK_USER_FAILURE = 'takeback/api/PROMOTE_ADDRESSBOOK_USER_FAILURE';

export const DEMOTE_ADDRESSBOOK_USER = 'takeback/api/DEMOTE_ADDRESSBOOK_USER';
export const DEMOTE_ADDRESSBOOK_USER_SUCCESS = 'takeback/api/DEMOTE_ADDRESSBOOK_USER_SUCCESS';
export const DEMOTE_ADDRESSBOOK_USER_FAILURE = 'takeback/api/DEMOTE_ADDRESSBOOK_USER_FAILURE';

export const REMOVE_ADDRESSBOOK_USER = 'takeback/api/REMOVE_ADDRESSBOOK_USER';
export const REMOVE_ADDRESSBOOK_USER_SUCCESS = 'takeback/api/REMOVE_ADDRESSBOOK_USER_SUCCESS';
export const REMOVE_ADDRESSBOOK_USER_FAILURE = 'takeback/api/REMOVE_ADDRESSBOOK_USER_FAILURE';

const initialState = Immutable.Map();

// Reducers
export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case GET_ADDRESSBOOKS_SUCCESS:
            return state.mergeDeep(action.addressbooks.reduce((map, addressbook) => {
                return map.set(addressbook.get('id'), addressbook);
            }, Immutable.Map()));

        case LEAVE_ADDRESSBOOK_SUCCESS:
            return state.delete(action.data + '');

        case INVITE_ADDRESSBOOK_SUCCESS:
        case PROMOTE_ADDRESSBOOK_USER_SUCCESS:
        case DEMOTE_ADDRESSBOOK_USER_SUCCESS:
        case REMOVE_ADDRESSBOOK_USER_SUCCESS:

            /* eslint-disable no-case-declarations */
            const addressbook = action.data.get('addressbookId');
            return state.set(addressbook, state.get(addressbook)
                .set('members', state.getIn([addressbook, 'members']).update(() => action.data.get('members'))));

        default:
            return state;
    }
}

// Selectors
export function selectAddressbooks(state) {
    return state.addressbooks;
}

export function selectAddressbook(state, addressbook) {
    return state.addressbooks.get(addressbook);
}

// Actions
export function getAddressbooks(params = {}, options = {}) {
    return Object.assign({type: GET_ADDRESSBOOKS, params}, options);
}

export function getAddressbooksSuccess(addressbooks) {
    return {type: GET_ADDRESSBOOKS_SUCCESS, addressbooks};
}

export function getAddressbooksFailure(error) {
    return {type: GET_ADDRESSBOOKS_FAILURE, error};
}

export function createAddressbookSuccess(data) {
    return {type: CREATE_ADDRESSBOOK_SUCCESS, data};
}

export function createAddressbookFailure(errors) {
    return {type: CREATE_ADDRESSBOOK_FAILURE, errors};
}

export function leaveAddressbookSuccess(data) {
    return {type: LEAVE_ADDRESSBOOK_SUCCESS, data};
}

export function leaveAddressbookFailure(errors) {
    return {type: LEAVE_ADDRESSBOOK_FAILURE, errors};
}

export function promoteAddressbookUserSuccess(data) {
    return {type: PROMOTE_ADDRESSBOOK_USER_SUCCESS, data};
}

export function promoteAddressbookUserFailure(errors) {
    return {type: PROMOTE_ADDRESSBOOK_USER_FAILURE, errors};
}

export function demoteAddressbookUserSuccess(data) {
    return {type: DEMOTE_ADDRESSBOOK_USER_SUCCESS, data};
}

export function demoteAddressbookUserFailure(errors) {
    return {type: DEMOTE_ADDRESSBOOK_USER_FAILURE, errors};
}

export function inviteAddressbookSuccess(data) {
    return {type: INVITE_ADDRESSBOOK_SUCCESS, data};
}

export function inviteAddressbookFailure(errors) {
    return {type: INVITE_ADDRESSBOOK_FAILURE, errors};
}

export function removeAddressbookUserSuccess(data) {
    return {type: REMOVE_ADDRESSBOOK_USER_SUCCESS, data};
}

export function removeAddressbookUserFailure(errors) {
    return {type: REMOVE_ADDRESSBOOK_USER_FAILURE, errors};
}
